import { useCallback } from 'react';
import { useMarketDetail } from '../../../queries/useMarketDetail';
import { useMemberRequestsAvailability } from '../queries/useMemberRequestsAvailability';
import { usePostFavoriteMarket } from '../../../queries/usePostFavoriteMarket';
import { usePostMemberRequests } from '../queries/usePostMemberRequests';
import { useShowMemberRequestsCompleteBottomSheet } from './useShowMemberRequestsCompleteBottomSheet';
import { useShowMarketCouponListBottomSheet } from '../../../hooks/useShowMarketCouponListBottomSheet';
import { useLogClickCouponList } from './useLogClickCouponList';
import { useLogClickRequestCoupon } from './useLogClickRequestCoupon';

export const usePressCouponView = (marketId: number) => {
  const { data: marketDetail } = useMarketDetail(marketId);
  const { data: memberRequestAvailable } =
    useMemberRequestsAvailability(marketId);
  const logClickCouponList = useLogClickCouponList();
  const logClickRequestCoupon = useLogClickRequestCoupon();

  const {
    mutateAsync: postFavoriteMarket,
    isPending: loadingPostFavoriteMarket,
  } = usePostFavoriteMarket(marketId);

  const {
    mutateAsync: postMemberRequests,
    isPending: loadingPostMemberRequests,
  } = usePostMemberRequests(marketId);

  const { show: showMemberRequestsCompleted } =
    useShowMemberRequestsCompleteBottomSheet();

  const { show: showMarketCouponList } = useShowMarketCouponListBottomSheet();

  return {
    action: useCallback(async () => {
      if (!marketDetail) return;
      if (memberRequestAvailable) {
        if (memberRequestAvailable.availability.is_requested) {
          // disabled
          return;
        }

        if (memberRequestAvailable.availability.is_available_request) {
          //마켓에 쿠폰 요청하기

          //마켓 좋아요 여부 먼저 확인하고,
          if (!marketDetail.market.favorite) {
            //마켓 좋아요 요청 보내기
            await postFavoriteMarket();
          }

          logClickRequestCoupon();

          //찌르기 요청 보내기
          await postMemberRequests();
          //바텀시트 열기
          showMemberRequestsCompleted({
            marketThumbnail: marketDetail.market.image,
          });
          return;
        }
      }

      logClickCouponList();
      showMarketCouponList({ marketId });
      //쿠폰함 열기
    }, [
      logClickRequestCoupon,
      logClickCouponList,
      marketDetail,
      marketId,
      memberRequestAvailable,
      postFavoriteMarket,
      postMemberRequests,
      showMarketCouponList,
      showMemberRequestsCompleted,
    ]),
    loading: loadingPostFavoriteMarket || loadingPostMemberRequests,
  };
};
